<template>
  <f7-page name="home">
    <f7-navbar id="navbar">
      <f7-nav-left>
        <img :src=$session_logo />
      </f7-nav-left>
      <f7-nav-right>
        <!-- <h2>{{ $t('welcome') }}</h2> -->
        <!--div class="locale-changer">
          <select v-model="$i18n.locale">
            <option v-for="locale in $i18n.availableLocales" :key="`locale-${locale}`" :value="locale">{{ locale }}</option>
          </select>
        </div-->
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar bottom>
      <small>{{ $t('copyright') }} v.1.1  <span v-if="registered_by_name">for {{ registered_by_name }}</span></small>
    </f7-toolbar>
    <f7-block>
      <Markdown :source="markdown" />
      <p>
        {{ $t('home_recaptcha_line_1') }}
        <f7-link href="https://policies.google.com/privacy?hl=ro" target="_blank" external>{{ $t('home_recaptcha_line_2') }}</f7-link>{{ $t('home_recaptcha_line_3') }}
        <f7-link href="https://policies.google.com/terms?hl=ro" target="_blank" external>{{ $t('home_recaptcha_line_4') }}</f7-link> {{ $t('home_recaptcha_line_5') }}
      </p>
    </f7-block>

    <f7-list>
      <f7-list-item link="#" id="1" name="register" @click="register_validation">{{ $t('home-register') }}</f7-list-item>
    </f7-list>
    <f7-list v-if="$keycloak">
      <f7-list-item divider :title="$t('home-existing_account')"></f7-list-item>
      <f7-list-item link="#" v-if="authenticated" @click="logout">{{ $t('disconnect') }}</f7-list-item>
      <f7-list-item link="#" v-else @click="login">{{ $t('home-my_account') }}</f7-list-item>
    </f7-list>

  </f7-page>
</template>

<script>
  import { useStore, f7 } from 'framework7-vue';
  import { request } from 'framework7';
  import Markdown from 'vue3-markdown-it';
  import './.modernizrrc';
  import $ from 'dom7';

  export default {
    props: {
      f7route: Object,
      f7router: Object,
      markdown: String,
    },
    components: {
      Markdown,
    },
    data() {
      return {
        authenticated: false,
        // score  0.7 - valori intre 0 - 1, 0.7 cred că este destul de strict.
        captcha_min_score: 0.5, 
        progress: 0,
        get token() {
          return localStorage.getItem('token');
        },
        set token(value) {
          localStorage.setItem('token', value);
        },
        http500_show_alert: true,
        registered_by_name: null,
      };
    },
    mounted() {
      const self=this;

      /* console.log("m >>>");
       * const place_of_birth_list = useStore('place_of_birth_list');
       * f7.store.dispatch('getPlaceOfBirthList', { 'county':'BZ' });
       *  console.log(place_of_birth_list);
       * console.log("<<< m");
      */

      if(self.$keycloak) {
        self.authenticated=self.$keycloak.authenticated;
      }
      self.registered_by_name=localStorage.registered_by_name;
      f7.preloader.show();
      request({
        beforeSend: function (xhr) {
          xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
        },
        method:"post",
        url: "/v/caps",
        data: {
          caps: JSON.stringify(Modernizr),
        },
        success: function (data, status, xhr) {
          f7.preloader.hide();
        },
        error: function(xhr, status, message) {
          f7.preloader.hide();
          self.http500(status, message);
        },
        dataType: 'json'
      });
    },
    methods: {
      login() {
        this.$keycloak.login();
      },
      logout() {
        localStorage.clear();
        this.$keycloak.logout();
      },
      // 500 status
      http500(status, message) {
        const self=this;
        self.http500_show_alert=true;
        switch(status) {
          case 500:
            self.http500_show_alert=false;
            self.f7router.navigate('/error',{props:{status, message}});
            break;
          case 419:
            self.http500_show_alert=false;
            self.f7router.navigate('/expired');
            break;
        }
      },

      async register_validation(){
        const self = this;
        f7.preloader.show();
        await this.$recaptchaLoaded();
        const g_token = await this.$recaptcha('registervalidation');
        if(g_token != null){
          request({
            beforeSend: function (xhr) {
              xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
            },
            method: 'post',
            url: '/v/captcha',
            data: {
              'response': g_token,
              'id': 1,
              'recaptcha': 'registervalidation',
            },
            success: function (data, status, xhr) {
              f7.preloader.hide();
              if(data.pass) 
                self.f7router.navigate('/register');
              else
                f7.dialog.alert(self.$t('recaptcha_robot-detected'),self.$t('error'));
            },
            error: function (xhr, status, message) {
              f7.preloader.hide();
              self.http500(status, message);
              if(self.http500_show_alert)
                f7.dialog.alert('('+status+') '+message, self.$t('error'));
            },
            dataType: 'json'
          });
        } else{
          f7.dialog.alert('Tokenul returnat este null (reCAPTCHA)');
          f7.preloader.hide();
        }
      },
    },
  };  
</script>
